import type { ComponentPropsWithoutRef } from "react";

import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

type Props = ComponentPropsWithoutRef<typeof Switch> & {
  label: string;
  labelPosition?: "left" | "right";
};

export default function ToggleButton({
  label,
  labelPosition = "right",
  ...props
}: Props) {
  return (
    <Label className="gap-4 items-center flex">
      {labelPosition === "left" && (
        <span className="cursor-pointer">{label}</span>
      )}
      <Switch {...props} />
      {labelPosition === "right" && (
        <span className="cursor-pointer">{label}</span>
      )}
    </Label>
  );
}
